<div class="page">
  <div class="header">
    <div>
      <h2>{{ "pages.agentSetup.title" | translate }}</h2>
    </div>
    <app-page-help>{{ "pages.agentSetup.subtitle" | translate }}</app-page-help>
  </div>

  <nb-card class="setup-card" alAnchor="agents.setup-card">
    <nb-card-body>
      <nb-tabset routeParam="tab" (changeTab)="onTabChange($event)">
        <nb-tab
          *ngFor="let tab of tabs; trackBy: trackTab"
          [tabId]="tab.key"
          [route]="tab.key"
          [tabTitle]="tab.titleKey | translate"
          [tabIcon]="tab.icon"
          [active]="tab.key === active"
          [lazyLoad]="true"
        >
          <ng-template nbTabTitle>
            <span class="tab-text" [alAnchor]="'tab.' + tab.key" [nbTooltip]="'pages.agentSetup.tabs.' + tab.key | translate">{{ tab.titleKey | translate }}</span>
          </ng-template>
          <ng-container [ngSwitch]="tab.key">
            <app-learnings *ngSwitchCase="'learnings'"></app-learnings>
            <app-skills *ngSwitchCase="'skills'"></app-skills>
            <app-mcp-connectors *ngSwitchCase="'mcp'"></app-mcp-connectors>
            <app-guardrails *ngSwitchCase="'guardrails'" [embedded]="true"></app-guardrails>
          </ng-container>
        </nb-tab>
      </nb-tabset>
    </nb-card-body>
  </nb-card>
</div>
